import { Component, OnInit } from '@angular/core';
import { StatusFirebaseService } from '@mobile/app/services/firebase/status-firebase.service';

@Component({
  selector: "app-loja-fechada",
  templateUrl: "./loja-fechada.component.html",
  styleUrls: ["./loja-fechada.component.scss"],
})
export class LojaFechadaComponent implements OnInit {
  lojaFechada$ = this.statusService.getLojaFechada();

  constructor(private statusService: StatusFirebaseService) {}

  ngOnInit() {}
}
